import TapStory from './TapStory.vue';
import TapStoryList from './TapStoryList.vue';
export default {
  TapStory,
  TapStoryList,
};
